import React, { useState, useEffect } from "react";
import { parseConditions } from "components/collections/util/filters";
import l from "components/util/l";

const MultipleCondition = ({ 
  columns, 
  condition, 
  depth,
  showOperator, 
  onChange, 
  onDelete 
}) => {
  return <div className="d-flex justify-content-between align-items-center w-100 my-2">

    {
      showOperator
        ? <select 
            className="form-control mr-3" 
            style={{ width: "10%", minWidth: "70px" }}
            value={condition?.operator}
            onChange={e => onChange({ ...condition, operator: e.target.value })}
          >
            <option value="AND">
              {l("Y%CA073")}
            </option>
            <option value="OR">
              {l("O%CA074")}
            </option>
          </select> 
        : <span 
            className="mr-3"
            style={{ width: "10%", minWidth: "70px" }}
          >
            {l("Donde%CA075")}
          </span>
    }
    
    <div 
      className="w-100 card card-body"
      style={{
        backgroundColor: `rgba(0, 0, 0, ${0.015 * depth})`,
      }}
    >
      <FilterForm
        columns={columns}
        isSubQuery={true}
        filters={condition.conditions}
        depth={depth}
        onChange={internalConditions => onChange({ ...condition, conditions: internalConditions })}
        onDelete={onDelete}
      />
    </div>

  </div>;
}

const SingleCondition = ({ 
  columns, 
  condition, 
  showOperator, 
  onChange, 
  onDelete 
}) => {
  return <div className="d-flex justify-content-between align-items-center w-100">

    {
      showOperator
        ? <select 
            className="form-control mr-3" 
            style={{ width: "10%", minWidth: "70px" }}
            value={condition?.operator}
            onChange={e => onChange({ ...condition, operator: e.target.value })}
          >
            <option value="AND">
              {l("Y%CA073")}
            </option>
            <option value="OR">
              {l("O%CA074")}
            </option>
          </select> 
        : <span 
            className="mr-3"
            style={{ width: "10%", minWidth: "70px" }}
          >
            {l("Donde%CA075")}
          </span>
    }

    <select 
      className="form-control my-2" 
      style={{width: "30%"}}
      onChange={e => onChange({ ...condition, column: e.target.value })}
      value={condition?.column}
    >
      {
        columns.map((column) => (
          <option key={column.name} value={column.name}>{column.label}</option>
        ))
      }
    </select>

    <select 
      className="form-control my-2"
      style={{width: "30%"}}
      onChange={e => onChange({ ...condition, condition: e.target.value })}
      value={condition?.condition}
    >
      <option value="=">{l("Igual%CA076")}</option>
      <option value="!=">{l("Diferente%CA077")}</option>
      <option value=">">{l("Mayor que%CA078")}</option>
      <option value="<">{l("Menor que%CA079")}</option>
      <option value=">=">{l("Mayor o igual que%CA080")}</option>
      <option value="<=">{l("Menor o igual que%CA081")}</option>
      <option value="contains">{l("Contiene%CA082")}</option>
      <option value="not_contains">{l("No contiene%CA083")}</option>
    </select>

    <input 
      type="text" 
      style={{width: "30%"}}
      className="form-control my-2"
      defaultValue={condition?.value}
      onBlur={e => onChange({ ...condition, value: e.target.value })}
    />

    <button
      className="btn ml-2 text-danger"
      onClick={onDelete}
    >
      <i className="fas fa-trash"></i>
    </button>

  </div>;
}

const FilterForm = ({ 
  columns, 
  filters = [],
  filterDefault,
  depth = 0,
  isSubQuery = false,
  onChange = () => {},
  onDelete = () => {},
  onClose = () => {},
  updateFilters = () => {},
  updateQuery = () => {},
}) => {

  const [conditions, setConditions] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [isErrorShown, setIsErrorShown] = useState(false);

  const _onClickChangeFilters = (conditions) => {
    let parsedQuery = parseConditions(conditions);
    updateFilters(conditions);
    updateQuery(parsedQuery);
  }

  const onAddSingleCondition = (conditions) => {
    const newConditions = [...conditions];
    if(newConditions.length == 0) newConditions.push({ column: filterDefault??columns[0].name, condition: "=", value: "", type: "SINGLE" });
    else newConditions.push({ operator: "AND", column: filterDefault??columns[0].name, condition: "=", value: "", type: "SINGLE" });
    return newConditions;
  }

  const onAddMultipleCondition = (conditions) => {
    const newConditions = [...conditions];
    if(newConditions.length == 0) newConditions.push({ type: "MULTIPLE", conditions: [] });
    else newConditions.push({ operator: "AND", type: "MULTIPLE", conditions: [] });
    return newConditions;
  }

  const onChangeCondition = (index, newCondition) => {
    const newConditions = [...conditions];
    newConditions[parseInt(index)] = newCondition;
    setConditions(newConditions);
  }

  const onDeleteCondition = (index) => {
    const newConditions = [...conditions];
    newConditions.splice(index, 1);
    setConditions(newConditions);
  }

  useEffect(() => {
    onChange(conditions);
  }, [conditions]);

  useEffect(() => {
    if(!loaded) {
      setConditions(filters?.length > 0 ? filters : onAddSingleCondition([]));
      setLoaded(true);
    }
  }, [filters]);

  return (
    <div>

      {
        !isSubQuery && 
          <div className="d-flex justify-content-between align-items-center w-100 mb-2">
            <h3>{l("Filtrar por%CA086")}</h3>
            <div className="d-flex mt-2">
              <button 
                className="btn btn-sm btn-outline-primary mr-3"
                onClick={() => setConditions(onAddSingleCondition(conditions))}
              >
                <i className="fas fa-plus mr-1"></i>
                {l("Agregar condición%CA084")}
              </button>
              {/* <button 
                className="btn btn-sm btn-outline-primary"
                onClick={() => setConditions(onAddMultipleCondition(conditions))}
              >
                <i className="fas fa-plus"></i>
                {l("Agregar condición múltiple%CA085")}
              </button> */}
            </div>
          </div>
      }

      {
        isSubQuery &&
          <div className="d-flex justify-content-end align-items-center w-100">
            <button 
              class="btn mr-3"
              type="button" 
              id="dropdownMenuButton" 
              data-toggle="dropdown" 
              aria-haspopup="true" 
              aria-expanded="false"
            >
              <i className="fas fa-plus"></i>
            </button>
            <div class="dropdown-menu">
              <span 
                class="dropdown-item" 
                style={{cursor: "pointer"}}
                onClick={() => setConditions(onAddSingleCondition(conditions))}
              >
                <i className="fas fa-plus"></i> {l("Agregar condición%CA084")}
              </span>
              <span
                class="dropdown-item"
                style={{cursor: "pointer"}}
                onClick={() => setConditions(onAddMultipleCondition(conditions))}
              >
                <i className="fas fa-plus"></i> {l("Agregar condición múltiple%CA085")}
              </span>
            </div>
            <button
              className="btn"
              onClick={onDelete}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
      }

      {
        conditions.map((condition, index) => (
          condition.type == "SINGLE"
            ? <SingleCondition 
                key={index} 
                columns={columns}
                condition={condition}
                filterDefault={filterDefault}
                showOperator={index > 0}
                onDelete={() => onDeleteCondition(index)}
                onChange={newCondition => onChangeCondition(index, newCondition)}
              />
            : <MultipleCondition
                key={index}
                columns={columns}
                condition={condition}
                depth={depth + 1}
                showOperator={index > 0}
                onDelete={() => onDeleteCondition(index)}
                onChange={newCondition => onChangeCondition(index, newCondition)}
              />
        ))
      }

      {
        isErrorShown &&
          <div className="alert alert-danger mt-3">
            <p className="m-0 p-0">
              {l("Debe agregar al menos una condición para poder aplicar los filtros%CA087")}
            </p>
          </div>
      }

      {
        !isSubQuery &&
          <div className="d-flex justify-content-end align-items-center w-100 mt-3">
            <button
              className="btn btn-primary mr-3"
              onClick={() => {
                
                if(conditions.length == 0 || (conditions.length == 1 && !conditions[0].value)) {
                  setIsErrorShown(true);
                  return;
                }

                _onClickChangeFilters(conditions);
                onClose();

              }}
            >
              {l("Aplicar%GA086")}
            </button>
            <button 
              className="btn btn-outline-danger"
              onClick={() => {
                _onClickChangeFilters([]);
                onClose();
              }}
            >
              {l("Limpiar%GA087")}
            </button>
          </div>
      }

    </div>
  );

}

export default FilterForm;